import { showPopupAsync } from './popup-core.js';
import { csrfFetchJson } from './ct/utils/csrf-fetch.js';

/**
 * @param {string} popupId
 * @param {string} url
 * @param {URLSearchParams|FormData} body
 * @param {(response: any) => string} pickContent
 * @param {Object} [options] Forwarded to {@link showPopupAsync}.
 * @returns {Promise<string|null>} The content that was shown, or null when none was.
 */
function showPopupFromJson(popupId, url, body, pickContent, options = {}) {
  return showPopupAsync(
    popupId,
    (signal) => csrfFetchJson(url, { method: 'POST', body: body, signal: signal }).then(pickContent),
    options,
  );
}

export { showPopupFromJson };
